import { Card } from '@drone-js/core';
import styled from 'styled-components';

// Temporary Fix for padding issues
const WalletCard = styled(Card)`
    * {
        box-sizing: border-box;
    }
`;

export default WalletCard;
